import {applyMiddleware, compose, createStore} from 'redux';

import thunk from 'redux-thunk';
import logger from 'redux-logger';

import rootReducer from './rootReducer';

const middleware = [];

middleware.push(thunk);

if (process.env.CLIENT) {
  if (process.env.REDUX_LOGGER === 'true') {
    middleware.push(logger);
  }
}

export default function configureStore(initialState) {
  const store = createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(...middleware),
      process.env.CLIENT && window.devToolsExtension
        ? window.devToolsExtension()
        : f => f
    )
  );

  if (module.hot) {
    module.hot.accept('./rootReducer', () => {
      const nextRootReducer = require('./rootReducer').default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./store/configureStore.js